module.exports = __webpack_public_path__ + "static/media/breadcrumb_logo_color.979ff275.svg";